// Pricing dot-matrix price text
document.addEventListener("DOMContentLoaded", () => {
  const wrap = document.querySelector(".pricing-dots-wrap");
  const canvas = document.getElementById("pricing-dots");
  if (!wrap || !canvas) return;

  const ctx = canvas.getContext("2d");
  const REDUCED = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const TEXT = "19,999";
  const FONT = `'JetBrains Mono', monospace`;
  const FONT_WEIGHT = 700;
  const MAX_DOTS = 2800;

  let dots = [];
  let visible = false;
  let started = false;
  let raf = 0;
  let t0 = 0;
  let dpr = 1;
  let W = 0;
  let H = 0;
  let priceX = 0;
  let priceWidth = 0;
  let priceFontSize = 0;

  function makeSprite(inner, outer) {
    const s = document.createElement("canvas");
    s.width = 32;
    s.height = 32;
    const g = s.getContext("2d");
    const grd = g.createRadialGradient(16, 16, 0, 16, 16, 16);
    grd.addColorStop(0, inner);
    grd.addColorStop(0.45, outer);
    grd.addColorStop(1, "rgba(0,0,0,0)");
    g.fillStyle = grd;
    g.fillRect(0, 0, 32, 32);
    return s;
  }

  // Vivid sprite: white-hot core fading to a saturated blue edge, drawn
  // at full opacity so the price reads dense and saturated.
  const coreSprite = makeSprite("rgba(255,255,255,1)", "rgba(56,189,248,1)");
  // After the reveal animation completes the dots are static; the loop
  // stops (leaving the final frame on the canvas) instead of redrawing
  // every frame, so it never competes with Lenis' scroll rAF.
  const SETTLE_MS = 1500;

  function measure() {
    dpr = Math.min(window.devicePixelRatio || 1, 2);
    const rect = wrap.getBoundingClientRect();
    W = Math.max(1, Math.floor(rect.width * dpr));
    H = Math.max(1, Math.floor(rect.height * dpr));
    canvas.width = W;
    canvas.height = H;
  }

  function buildDots() {
    const c = document.createElement("canvas");
    c.width = W;
    c.height = H;
    const g = c.getContext("2d");
    let size = Math.floor(H * 0.72);
    g.font = `${FONT_WEIGHT} ${size}px ${FONT}`;
    g.textAlign = "left";
    g.textBaseline = "middle";
    let tw = g.measureText(TEXT).width;
    if (tw > W * 0.78) {
      size = Math.floor((size * W * 0.78) / tw);
      g.font = `${FONT_WEIGHT} ${size}px ${FONT}`;
    }
    priceFontSize = size;
    priceWidth = g.measureText(TEXT).width;
    const centered = window.matchMedia("(max-width: 768px)").matches;
    const inrSize = Math.max(12 * dpr, Math.floor(priceFontSize * 0.18));
    g.font = `${FONT_WEIGHT} ${inrSize}px ${FONT}`;
    const inrWidth = g.measureText("INR").width;
    const gap = 10 * dpr;
    priceX = centered ? (W - (priceWidth + gap + inrWidth)) / 2 : 4 * dpr;
    g.font = `${FONT_WEIGHT} ${size}px ${FONT}`;
    g.fillStyle = "#ffffff";
    g.fillText(TEXT, priceX, H / 2 + H * 0.02);
    const data = g.getImageData(0, 0, W, H).data;

    let step = Math.max(5, Math.ceil(5 * dpr));
    while (Math.ceil(W / step) * Math.ceil(H / step) * 0.5 > MAX_DOTS)
      step += 2;

    const d = [];
    for (let y = 0; y < H; y += step) {
      for (let x = 0; x < W; x += step) {
        if (data[(y * W + x) * 4 + 3] > 128) d.push({ x, y });
        if (d.length >= MAX_DOTS) break;
      }
      if (d.length >= MAX_DOTS) break;
    }
    dots = d;
  }

  function draw(now) {
    ctx.clearRect(0, 0, W, H);
    const t = (now - t0) / 1000;
    const n = dots.length;
    for (let i = 0; i < n; i++) {
      const d = dots[i];
      const delay = 0.08 + (d.x / W) * 0.6 + (Math.abs(d.x - W / 2) / W) * 0.25;
      const p =
        REDUCED || t < delay
          ? REDUCED
            ? 1
            : 0
          : Math.min(1, (t - delay) / 0.35);
      if (p <= 0) continue;
      const e = 1 - Math.pow(1 - p, 3);
      const r = 4.6 * dpr * (0.6 + 0.4 * e);
      ctx.globalAlpha = e;
      ctx.drawImage(coreSprite, d.x - r / 2, d.y - r / 2, r, r);
    }
    ctx.globalAlpha = 1;
    ctx.font = `${FONT_WEIGHT} ${Math.max(12 * dpr, Math.floor(priceFontSize * 0.18))}px ${FONT}`;
    ctx.textAlign = "left";
    ctx.textBaseline = "alphabetic";
    ctx.fillStyle = "rgba(255,255,255,0.78)";
    ctx.fillText(
      "INR",
      priceX + priceWidth + 10 * dpr,
      H / 2 - priceFontSize * 0.22,
    );
  }

  function loop(now) {
    if (!visible) {
      raf = 0;
      return;
    }
    if (!started) {
      started = true;
      t0 = now;
    }
    draw(now);
    if (now - t0 > SETTLE_MS) {
      raf = 0;
      return;
    }
    raf = requestAnimationFrame(loop);
  }

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        visible = entry.isIntersecting;
        if (visible && !REDUCED && !raf) raf = requestAnimationFrame(loop);
      });
    },
    { threshold: 0.3 },
  );
  io.observe(wrap);

  function rebuild() {
    measure();
    buildDots();
    if (REDUCED) {
      draw(performance.now());
    } else if (visible && !raf) {
      raf = requestAnimationFrame(loop);
    }
  }

  if (typeof ResizeObserver !== "undefined") {
    new ResizeObserver(rebuild).observe(wrap);
  }
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(rebuild);
  }
  rebuild();
});

// Scroll sequence: while the section slides into view, the leather purse is
// revealed from the card's bottom edge, finishing exactly when the card
// pins. Once sticky, the VISA card pops out from behind the purse and spins.
// The card stays sticky until the section's end, where it scrolls out of the
// view naturally. Scrolling back up plays everything in reverse — the card
// pops back in behind the purse — and the sequence replays every visit.
document.addEventListener("DOMContentLoaded", () => {
  const section = document.getElementById("pricing");
  const stage = document.getElementById("pricing-stage");
  const tilt = document.getElementById("pricing-card-tilt");
  const card = section ? section.querySelector(".pricing-card") : null;
  const cardPop = section ? section.querySelector(".pricing-card-pop") : null;
  const wallet = section ? section.querySelector(".pricing-wallet") : null;
  if (!section || !stage || !tilt || !card || !cardPop || !wallet) return;

  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reduced) {
    stage.style.setProperty("--wallet-p", 1);
    stage.style.setProperty("--pop-p", 1);
    stage.style.setProperty("--spin-p", 1);
    return;
  }

  const clamp = (v, min, max) => Math.min(max, Math.max(min, v));
  const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);
  const easeInOut = (t) =>
    t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;

  // Pinned-stage boundaries (p = runway progress). The card pops only
  // after the wallet has fully risen (which happens exactly when the card
  // pins) plus a fixed scroll delay, so the reveal feels unhurried.
  const POP_DELAY = 0.12;
  const POP_END = 0.42;
  const SPIN_END = 0.74;

  let runway = 1;
  let walletH = 250;
  // Scroll distance the wallet needs to travel from fully hidden (its top
  // below the card container's bottom edge) to its resting slot.
  let riseBase = 230;
  let cardH = 540;
  let pinTop = 100;
  let padTop = 0;
  let stickyReady = false;
  let settled = false;
  let raf = 0;

  const stageRange = (p, from, to) => clamp((p - from) / (to - from), 0, 1);

  function measure() {
    runway = Math.max(1, section.offsetHeight - window.innerHeight);
    walletH = wallet.getBoundingClientRect().height || 250;

    // The desktop sticky offset is fixed in CSS. Read it back here so the
    // scroll progress uses the same value as the visual sticky position.
    cardH = card.getBoundingClientRect().height || 540;
    card.style.setProperty("--card-h", `${cardH}px`);
    pinTop =
      parseFloat(getComputedStyle(card).top) ||
      112;
    padTop = parseFloat(getComputedStyle(section).paddingTop) || 0;

    // Distance the card travels from its resting spot (fully hidden,
    // clipped below the card's bottom edge) up to its slot position.
    // The card's `bottom` offset cancels out of the equation; what
    // matters is the grid's bottom padding (the clip line) plus the
    // card's own height, plus a little slack.
    const grid = section.querySelector(".pricing-grid");
    const gridBottom = grid
      ? parseFloat(getComputedStyle(grid).paddingBottom)
      : 48;
    // Wallet slide: at rest the wallet must sit entirely below the card
    // container (its top past the card's inner bottom edge = the grid's
    // bottom padding), so it visibly slides up from underneath. The
    // resting slot keeps 32% of it clipped, showing the upper portion.
    riseBase = walletH * 0.68 + gridBottom + 12;
    const cardH2 = cardPop.getBoundingClientRect().height || 180;
    const popBottom = parseFloat(getComputedStyle(cardPop).bottom);
    const travel =
      (Number.isFinite(popBottom) ? popBottom : 100) + gridBottom + cardH2 + 24;
    stage.style.setProperty("--pop-travel", `${travel}px`);
  }

  function update() {
    const rect = section.getBoundingClientRect();
    const vh = window.innerHeight;

    // Do not allow the sticky state to engage while any part of the pricing
    // card is still outside the viewport. The class is added only after the
    // card has entered completely, which also delays the scroll animation's
    // pinned phase until the card can be seen in full.
    const cardRect = card.getBoundingClientRect();
    if (!stickyReady && cardRect.top >= 0 && cardRect.bottom <= vh) {
      stickyReady = true;
      card.classList.add("is-sticky-ready");
    }

    // Entry: the section sliding into view. Wait until the entire pricing
    // card is inside the viewport before starting the wallet reveal. This
    // keeps the card's lower edge from being hidden while the animation
    // begins, especially on shorter desktop viewports.
    const entryStart = vh - padTop - cardH;
    const entry = clamp(
      (entryStart - rect.top) / Math.max(1, entryStart - (pinTop - padTop)),
      0,
      1,
    );

    // Runway progress: meaningful only once pinned — drives pop + spin.
    const p = clamp(-rect.top / runway, 0, 1);

    const walletP = easeOutCubic(entry);

    // Runway progress at which the card pins = the wallet fully risen.
    // The pop waits for that moment, plus POP_DELAY of runway, so the
    // card never starts moving before the wallet has finished sliding in.
    const pinP = clamp((padTop - pinTop) / runway, 0, 1);
    const popStart = Math.min(0.9, pinP + POP_DELAY);

    // No overshoot easing: the card must never travel past its resting
    // slot, or it would jump out of the pricing card's bounds.
    const popP = easeOutCubic(stageRange(p, popStart, POP_END));
    const spinP = easeInOut(stageRange(p, POP_END, SPIN_END));

    // The wallet slides up from fully hidden below the card container;
    // the card stays tucked behind it until the pop stage lifts it clear.
    const risePx = riseBase * (1 - walletP);

    stage.style.setProperty("--wallet-p", walletP);
    stage.style.setProperty("--pop-p", popP);
    stage.style.setProperty("--spin-p", spinP);
    stage.style.setProperty("--wallet-rise", `${risePx}px`);

    // Hover tilt only while the card rests above the purse.
    if (settled && p < SPIN_END) {
      settled = false;
      stage.style.setProperty("--tilt-enabled", 0);
    }
    if (!settled && p >= SPIN_END) {
      settled = true;
      stage.style.setProperty("--tilt-enabled", 1);
    }
  }

  function tick() {
    raf = 0;
    update();
  }

  function onScroll() {
    if (!raf) raf = requestAnimationFrame(tick);
  }

  function onResize() {
    measure();
    onScroll();
  }

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onResize);
  if (typeof ResizeObserver !== "undefined") {
    new ResizeObserver(onResize).observe(section);
  }

  // Jump straight to the correct progress if the page loads mid-sequence.
  measure();
  update();

  // Hover tilt — active only after the sequence completes.
  const MAX_TILT = 11;
  let tiltRaf = 0;

  tilt.addEventListener("mousemove", (e) => {
    if (!settled) return;
    const r = tilt.getBoundingClientRect();
    const px = (e.clientX - r.left) / r.width - 0.5;
    const py = (e.clientY - r.top) / r.height - 0.5;
    tilt.classList.add("is-hovering");
    if (!tiltRaf) {
      tiltRaf = requestAnimationFrame(() => {
        tiltRaf = 0;
        stage.style.setProperty("--tilt-x", `${py * -2 * MAX_TILT}deg`);
        stage.style.setProperty("--tilt-y", `${px * 2 * MAX_TILT}deg`);
      });
    }
  });

  tilt.addEventListener("mouseleave", () => {
    tilt.classList.remove("is-hovering");
    stage.style.setProperty("--tilt-x", "0deg");
    stage.style.setProperty("--tilt-y", "0deg");
  });
});
